import * as React from "react"
const AchivementIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#fff"
      d="M19.365 17.485c.63-.18 1.31-.3 1.65-.76.5-.69.03-1.89.3-2.72.26-.79 1.35-1.49 1.35-2.37 0-.89-1.09-1.58-1.35-2.38-.27-.82.2-2.03-.3-2.72-.51-.69-1.8-.62-2.5-1.12-.68-.5-1.01-1.76-1.84-2.03-.79-.26-1.79.56-2.67.56-.89 0-1.89-.82-2.68-.56-.83.27-1.16 1.53-1.84 2.03-.7.5-1.99.43-2.5 1.12-.5.69-.03 1.9-.3 2.72-.25.8-1.35 1.49-1.35 2.38 0 .88 1.1 1.58 1.35 2.37.27.83-.2 2.03.3 2.72.34.46 1.03.58 1.66.76l-2.04 4.36c-.2.42.16.89.62.81l1.76-.3c.41-.07.82.12 1.03.48l.9 1.54c.23.41.83.38 1.02-.04l2.07-4.43 2.07 4.43c.19.42.79.45 1.02.04l.9-1.54c.21-.36.62-.55 1.03-.48l1.76.3c.46.08.82-.39.62-.81zm-3.36-5 .29 1.698a.527.527 0 0 1-.764.555l-1.526-.803-1.533.803a.527.527 0 0 1-.763-.557l.296-1.696-1.239-1.208a.527.527 0 0 1 .29-.899l1.709-.253.766-1.545a.527.527 0 0 1 .945.001l.759 1.544 1.718.254a.527.527 0 0 1 .29.898z"
      data-original="#000000"
    />
  </svg>
)
export default AchivementIcon
